import React from "react";
import styleObj from "./style.module.scss";

export default function MyTitle(props) {
  let { mainTitle, subTitle, meta, title } = props;
  return (
    <>
      {meta?.is2021 && title ? (
        <div className={styleObj["title-wrap"]}>
          <img className={styleObj["title"]} src={title} />
        </div>
      ) : (
        <div className={styleObj["title-wrap"]}>
          <div className={styleObj["pendant"]}></div>
          <div className={styleObj["content"]}>
            <div className={styleObj["main-title"]}>{mainTitle}</div>
            <div className={styleObj["sub-title"]}>{subTitle}</div>
          </div>
          <div
            className={`${styleObj["pendant-right"]} ${styleObj["pendant"]}`}
          ></div>
        </div>
      )}
    </>
  );
}
